import { useState } from "react";
import { Loader2, MessageCircleQuestion, ChevronDown, Search } from "lucide-react";

const fmt = (s) => (s ? new Date(s).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

function QuestionCard({ item, open, onToggle }) {
  const answered = item.status === "answered";
  return (
    <div className="mc-card p-5" data-testid={`myq-item-${item.id}`}>
      <button onClick={onToggle} className="w-full text-left flex items-start justify-between gap-3" data-testid={`myq-toggle-${item.id}`}>
        <div className="min-w-0">
          <p className="text-[11px] text-slate-500">{fmt(item.created_at)} · ₹{item.amount}</p>
          <p className="mt-1 text-slate-100 leading-snug">{item.question_text}</p>
        </div>
        <span className="flex items-center gap-2 shrink-0">
          <span data-testid={`myq-status-${item.id}`} className={`text-[11px] rounded-full border px-2.5 py-0.5 flex items-center gap-1 ${answered ? "text-emerald-300 border-emerald-500/30" : "text-amber-300 border-amber-500/30"}`}>
            {answered ? "Answered" : <><Loader2 size={10} className="animate-spin" /> In progress</>}
          </span>
          <ChevronDown size={16} className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
        </span>
      </button>
      {open && (
        <div className="mt-4 rounded-xl bg-amber-500/5 border border-amber-500/15 px-4 py-3">
          {answered ? (
            <>
              <p className="text-[10px] uppercase tracking-wider text-amber-400/90 mb-1">
                Answer · {fmt(item.answered_at)}{item.chart_based ? " · Based on your birth chart" : ""}
              </p>
              <p className="text-sm text-slate-300 whitespace-pre-line leading-relaxed" data-testid={`myq-answer-${item.id}`}>{item.answer_text}</p>
            </>
          ) : (
            <p className="text-sm text-slate-400">We're reading your chart. Your answer will appear here shortly.</p>
          )}
        </div>
      )}
    </div>
  );
}

export function MyQuestions({ questions, onAsk }) {
  const [openId, setOpenId] = useState(questions[0]?.id);
  const [term, setTerm] = useState("");
  const list = questions.filter((q) => (q.question_text + " " + (q.answer_text || "")).toLowerCase().includes(term.toLowerCase()));

  if (!questions.length) {
    return (
      <div className="mc-card p-10 text-center" data-testid="myq-empty">
        <MessageCircleQuestion className="mx-auto text-amber-300" size={28} />
        <p className="mt-3 text-slate-300">You haven't asked any questions yet.</p>
        <button onClick={onAsk} className="btn-gold rounded-full px-6 py-2.5 text-sm mt-5" data-testid="myq-ask-btn">Ask Your First Question</button>
      </div>
    );
  }
  return (
    <div data-testid="my-questions">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
        <p className="text-sm text-slate-400"><span className="text-amber-200 font-semibold">{questions.length}</span> questions · {questions.filter((q) => q.status === "answered").length} answered</p>
        <div className="flex gap-2">
          <div className="relative">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
            <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search questions" data-testid="myq-search"
              className="rounded-full bg-[#0B1024] border border-amber-500/20 pl-8 pr-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-amber-400/60 w-full sm:w-56" />
          </div>
          <button onClick={onAsk} className="btn-gold rounded-full px-4 py-2 text-sm shrink-0" data-testid="myq-new-btn">Ask New</button>
        </div>
      </div>
      <div className="space-y-3">
        {list.map((q) => <QuestionCard key={q.id} item={q} open={openId === q.id} onToggle={() => setOpenId(openId === q.id ? null : q.id)} />)}
        {!list.length && <p className="text-sm text-slate-500 text-center py-6">No questions match your search.</p>}
      </div>
    </div>
  );
}
